import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';
import React from 'react';
import { ConfigProvider } from 'antd';
import antdEn from 'antd/es/locale/en_US';
import { darkTheme } from './themes/dark';
import { liteTheme } from './themes/lite';
import { useAppSelector } from './store';

// Роутер создаётся один раз на всё приложение: пересоздание на каждый рендер
// сбрасывает историю навигации и состояние загрузчиков.
const router = createBrowserRouter(routes);

const App = () => {
  const useDarkTheme = useAppSelector((state) => state.config.useDarkTheme);

  return (
    <ConfigProvider locale={antdEn} theme={useDarkTheme ? darkTheme : liteTheme}>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
};

export default App;
